import React from "react";
import { useSelector } from "react-redux";

import TagItem from "./Tags/TagItem";
import Timeseries from "./Timeseries/index.jsx";
import Gauge from "./Gauge";

import "./ProjStyles.scss";

export default function Card(props) {
  const { item } = props;
  const { tagsAsObj } = useSelector(state => state.tags);

  const getTagDetails = () => {
    const { Id, Attributes } = item;
    const { Duration } = Attributes;
    const Tags = tagsAsObj[Attributes?.SystemTag];
    return { ...Tags, Id, Duration };
  };

  return (
    <>
      {item.Type === "Gauge" && <Gauge {...props} />}
      {item.Type === "Tag" && <TagItem tagData={getTagDetails()} {...props} />}
      {item.Type === "Timeseries" && <Timeseries tagData={getTagDetails()} {...props} />}
    </>
  );
}
